import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-ac-cust-transes-age',
  templateUrl: './ac-cust-transes-age.component.html',
  styleUrls: ['./ac-cust-transes-age.component.css']
})
export class AcCustTransesAgeComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public grid?: GridOptions;

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2796))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_accusttransesage_grid').setLoadDataFunction({ method: 2797, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
            case 'date_tom':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        
        return Promise.all([
            this.loadCompanies()
        ]).then(() => {
            this.loadGrid();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    date_tom: string;
    date_today: string;
    date_not_today_warning: string;
}
